import React, { useState, useEffect } from 'react';
import {
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Checkbox,
  Container,
  FormControlLabel,
  Button,
  Box,
  Typography,
  Grid,
  Dialog, DialogTitle, DialogContent, DialogActions, Label
} from '@mui/material';
import { getTypes, getKinds, getCategories, getActiveReaders, addItem, getTemplateGroups } from "../../api/axios";
import "./newItem.css";
import { getUsername } from '../../context/AuthFunc';
import { useTranslation } from 'react-i18next';

const NewItem = () => {
  const [openEmptyReaders, setOpenEmptyReaders] = useState(false);
  const [openReadersModal, setOpenReadersModal] = useState(false);
  const [types, setTypes] = useState([]);
  const [kinds, setKinds] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedTypeName, setSelectedTypeName] = useState('');
  const [readers, setReaders] = useState([]);
  const [templateGroups, setTemplateGroups] = useState([]);
  const [formData, setFormData] = useState({
    type_id: '',
    kind_id: '',
    category_id: '',
    price: '',
    vat: '',
    disc: 0,
    desc: '',
    readers: [],
    template_id: '',
    allowed_days: '',
  });
  const [kindDetails, setKindDetails] = useState({
    days: '',
    entries: '',
    dailyPasses: '',
    timeFrom: '',
    timeTo: '',
    type_id: '',
    allowed_days: '',
  });
  const { t } = useTranslation('global');

  const formatAllowedDays = (allowed) => {
  if (!allowed) return '';

  const dayMap = {
    1: 'Pon',
    2: 'Uto',
    3: 'Sre',
    4: 'Čet',
    5: 'Pet',
    6: 'Sub',
    7: 'Ned'
  };

  return allowed
    .split(',')
    .map((num) => dayMap[num.trim()])
    .join(', ');
};

  useEffect(() => {
    fetchInitialData();
  }, []);

  const fetchInitialData = async () => {
    try {
      const typesData = await getTypes();
      const categoriesData = await getCategories();
      const kindsData = await getKinds();
      const readersData = await getActiveReaders();
      const templateGroupsData = await getTemplateGroups();

      setTypes(typesData || []);
      setCategories(categoriesData || []);
      setKinds(Array.isArray(kindsData) ? kindsData : []);
      setReaders(readersData || []);
      setTemplateGroups(templateGroupsData || []);
    } catch (error) {
      console.error("Greška pri učitavanju podataka:", error);
    }
  };

  const handleOpenReadersModal = () => setOpenReadersModal(true);
  const handleCloseReadersModal = () => setOpenReadersModal(false);

  const handleKindChange = (kindId) => {
    const selectedKind = kinds.find((kind) => kind.id === kindId);

    if (selectedKind) {
      const relatedType = types.find((type) => type.id === selectedKind.type);
      setFormData({
        ...formData,
        kind_id: kindId,
        type_id: selectedKind.type,
        allowed_days: selectedKind.allowed_days
      });

      setKindDetails({
        days: selectedKind.days || '0',
        entries: selectedKind.entries || '0',
        dailyPasses: selectedKind.daily || '0',
        timeFrom: selectedKind.from || '00:00:00',
        timeTo: selectedKind.to || '23:59:59',
        type_id: selectedKind.type || '',
        allowed_days: selectedKind.allowed_days || '',
      });

      setSelectedTypeName(relatedType ? relatedType.name : '');
      console.log(formData);

    }
  };

  const handleOpenEmptyReaders = () => setOpenEmptyReaders(true);
  const handleCloseEmptyReaders = () => setOpenEmptyReaders(false);

  const handleReaderChange = (e) => {
    const {value, checked} = e.target;  

    setFormData((prev)=>{
      if (value === 'all') {
        return {...prev, readers: checked ? readers.map(reader => reader.id) : []};
      }
      const id = Number(value);
      const updatedReaders = checked ? [...prev.readers, id] : prev.readers.filter(readerId => readerId !==id )
      return {...prev, readers: updatedReaders};
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const username = getUsername();
    const params = {
      price: formData.price,
      vat: formData.vat,
      type_id: formData.type_id,
      kind_id: formData.kind_id,
      category_id: formData.category_id,
      disc: formData.disc,
      user: username,
      readers: formData.readers.join(','),
      desc: formData.desc,
      template_id: formData.template_id,
      allowed_days: formData.allowed_days,
    };
    if (formData.readers.length == 0) {
      handleOpenEmptyReaders();
    }

    try {
      console.log(params);
      const response = await addItem(params);
      console.log('Item added successfully:', response.data);
    } catch (error) {
      console.error('Failed to add item:', error);
    }
  };

  return (
    <Container className="container-item" sx={{ p: 3, mt: 4 }} maxWidth="sm">
  <Typography variant="h4" gutterBottom>
    {t("priceList.newItem")}
  </Typography>
  <form onSubmit={handleSubmit} style={{ display:"flex", justifyContent:"center", alignItems:"center"}}>
    <Grid container spacing={2}>
      {/* Vrsta */}
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <InputLabel>{t("priceList.kind")}</InputLabel>
          <Select
            value={formData.kind_id}
            onChange={(e) => handleKindChange(e.target.value)}
          >
            {kinds.map((kind) => (
              <MenuItem key={kind.id} value={kind.id}>
                {kind.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      {/* Tip */}      
      <Grid item xs={12} sm={6}>
      <TextField
        fullWidth
        label={t("priceList.type")}
        value={selectedTypeName}
        InputProps={{ readOnly: true }}
      />
    </Grid>
    <Grid item xs={12} sm={12}>
      <Typography>{formatAllowedDays(kindDetails.allowed_days)}</Typography>
    </Grid>
      {/* Detalji Vrste */}
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label={t("priceList.numberOfDays")}
          value={kindDetails.days}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label={t("priceList.numberOfEntries")}
          value={kindDetails.entries}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={12} sm={4}>
        <TextField
          fullWidth
          label={t("priceList.dailyNumberOfEntries")}
          value={kindDetails.dailyPasses}
          InputProps={{ readOnly: true }}
        />
      </Grid>

      <Grid item xs={6}>
        <TextField
          fullWidth
          label={t("priceList.from")}
          value={kindDetails.timeFrom}
          InputProps={{ readOnly: true }}
        />
      </Grid>
      <Grid item xs={6}>
        <TextField
          fullWidth
          label={t("priceList.until")}
          value={kindDetails.timeTo}
          InputProps={{ readOnly: true }}
        />
      </Grid>

      {/* Kategorija */}
      <Grid item xs={12} sm={6}>
        <FormControl fullWidth required>
          <InputLabel>{t("priceList.category")}</InputLabel>
          <Select
            value={formData.category_id}
            onChange={(e) => setFormData({ ...formData, category_id: e.target.value })}
          >
            {categories.map((category) => (
              <MenuItem key={category.id} value={category.id}>
                {category.name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>

      {/* Cena */}
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          label={t("priceList.price")}
          type="number"
          value={formData.price}
          onChange={(e) => setFormData({ ...formData, price: e.target.value })}
        />
      </Grid>

      {/* PDV */}
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          required
          label={t("priceList.VAT")}
          type="number"
          value={formData.vat}
          onChange={(e) => setFormData({ ...formData, vat: e.target.value })}
        />
      </Grid>

      {/* Popust */}
      <Grid item xs={12} sm={6}>
        <TextField
          fullWidth
          label={t("priceList.discount")}
          type="number"
          value={formData.disc}
          onChange={(e) => setFormData({ ...formData, disc: e.target.value })}
        />
      </Grid>

      {/* Opis */}
      <Grid item xs={12}>
        <TextField
          fullWidth
          required
          label={t("priceList.description")}
          multiline
          rows={3}
          value={formData.desc}
          onChange={(e) => setFormData({ ...formData, desc: e.target.value })}
        />
      </Grid>
      <Grid item xs={12} sm={6}>

      <FormControl fullWidth>
        <InputLabel>{t("priceList.templateGroup")}</InputLabel>
        <Select
          value={formData.template_id}
          onChange={(e) => setFormData({ ...formData, template_id: e.target.value })}
        >
          {templateGroups.map((group) => (
            <MenuItem key={group.id} value={group.id}>{group.name}</MenuItem>
          ))}
        </Select>
      </FormControl>
      </Grid>

      {/* Čitači */}
      <Grid item xs={12}>
  <Button variant="outlined" onClick={handleOpenReadersModal}>
    {t("priceList.selectReaders")}
  </Button>
</Grid>



    <Dialog open={openEmptyReaders} onClose={handleCloseEmptyReaders} fullWidth maxWidth="sm">
      <DialogContent>
        <Typography>{t('priceList.emptyReaders')}</Typography>
      </DialogContent>
      
    </Dialog>
    <Dialog open={openReadersModal} onClose={handleCloseReadersModal} fullWidth maxWidth="sm">
  <DialogTitle>{t("priceList.readers")}</DialogTitle>
  <DialogContent>
    <FormControlLabel
      control={
        <Checkbox
          value="all"
          onChange={handleReaderChange}
          checked={formData.readers.length === readers.length}
        />
      }
      label={t("priceList.all")}
    />
    <Grid container spacing={1}>
      {readers.map((reader) => (
        <Grid item xs={12} sm={6} key={reader.id}>
          <FormControlLabel
            control={
              <Checkbox
                value={reader.id}
                checked={formData.readers.includes(Number(reader.id))}
                onChange={handleReaderChange}
              />
            }
            label={reader.name}
          />
        </Grid>
      ))}
    </Grid>
  </DialogContent>
  <DialogActions>
    <Button onClick={handleCloseReadersModal} color="primary" variant="contained">
      {t("priceList.confirm")}
    </Button>
  </DialogActions>
</Dialog>

      {/* Dugme */}
      <Grid item xs={12} sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button type="submit" variant="contained" color="primary" sx={{ width: "50%" }}>
        {t("priceList.addItem")}
        </Button>
      </Grid>
    </Grid>
  </form>
</Container>

  );
};

export default NewItem;